import React from "react";

/**
 * Inline SVG brand logos for the payment gateway modal.
 * Kept as React components so they scale crisply on hi-DPI screens
 * and don't depend on external CDNs (which can be blocked or slow).
 */

export const FlowLogo = ({ size = 28 }) => (
  <svg
    width={size * 2.2}
    height={size}
    viewBox="0 0 88 40"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Flow.cl"
    role="img"
  >
    <defs>
      <linearGradient id="flow-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#0050ff" />
        <stop offset="100%" stopColor="#0079ff" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="88" height="40" rx="9" fill="url(#flow-grad)" />
    <text
      x="44"
      y="27"
      textAnchor="middle"
      fontFamily="'Inter', system-ui, sans-serif"
      fontWeight="800"
      fontSize="17"
      fill="#fff"
      letterSpacing="-0.5"
    >
      flow
      <tspan fill="#a5d8ff" fontWeight="600">.cl</tspan>
    </text>
  </svg>
);

export const MercadoPagoLogo = ({ size = 28 }) => (
  <svg
    width={size * 2.2}
    height={size}
    viewBox="0 0 88 40"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Mercado Pago"
    role="img"
  >
    <defs>
      <radialGradient id="mp-circle" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#ffe680" />
        <stop offset="100%" stopColor="#fbd133" />
      </radialGradient>
    </defs>
    <rect x="0" y="0" width="88" height="40" rx="9" fill="#fff8d6" />
    {/* Stylized "handshake" mark — two cyan curves on a yellow circle */}
    <g transform="translate(8 6)">
      <circle cx="14" cy="14" r="14" fill="url(#mp-circle)" />
      <path
        d="M5 16 q4 -7 9 -3 q5 -4 9 3"
        stroke="#00b1ea"
        strokeWidth="2.6"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M7 18 q4 -4 7 -1 q3 -3 7 1"
        stroke="#0084c1"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        opacity="0.85"
      />
    </g>
    <text
      x="42"
      y="18"
      fontFamily="'Inter', system-ui, sans-serif"
      fontWeight="800"
      fontSize="11"
      fill="#0084c1"
      letterSpacing="-0.3"
    >
      Mercado
    </text>
    <text
      x="42"
      y="31"
      fontFamily="'Inter', system-ui, sans-serif"
      fontWeight="800"
      fontSize="11"
      fill="#0084c1"
      letterSpacing="-0.3"
    >
      Pago
    </text>
  </svg>
);

export const WebpayLogo = ({ size = 28 }) => (
  <svg
    width={size * 2.4}
    height={size}
    viewBox="0 0 96 40"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Webpay"
    role="img"
  >
    <rect x="0" y="0" width="96" height="40" rx="9" fill="#fff" stroke="#e5e7eb" />
    {/* Webpay's signature accent: a red rounded square */}
    <rect x="8" y="11" width="18" height="18" rx="4" fill="#e30613" />
    <path
      d="M12 17 l3 7 l2 -5 l2 5 l3 -7"
      stroke="#fff"
      strokeWidth="1.8"
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
    <text
      x="32"
      y="25"
      fontFamily="'Inter', system-ui, sans-serif"
      fontWeight="800"
      fontSize="13"
      fill="#0a3a5e"
      letterSpacing="-0.4"
    >
      Web<tspan fill="#e30613">pay</tspan>
    </text>
  </svg>
);

export const VisaLogo = ({ size = 28 }) => (
  <svg
    width={size * 2.2}
    height={size}
    viewBox="0 0 88 40"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Visa"
    role="img"
  >
    <rect x="0" y="0" width="88" height="40" rx="9" fill="#fff" stroke="#e5e7eb" />
    <text
      x="44"
      y="27"
      textAnchor="middle"
      fontFamily="'Inter', 'Helvetica Neue', sans-serif"
      fontStyle="italic"
      fontWeight="900"
      fontSize="22"
      fill="#1a1f71"
      letterSpacing="-0.5"
    >
      VISA
    </text>
    <rect x="14" y="29" width="60" height="2" fill="#f7b600" />
  </svg>
);

export const MastercardLogo = ({ size = 28 }) => (
  <svg
    width={size * 2.2}
    height={size}
    viewBox="0 0 88 40"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Mastercard"
    role="img"
  >
    <rect x="0" y="0" width="88" height="40" rx="9" fill="#fff" stroke="#e5e7eb" />
    <g transform="translate(28 8)">
      <circle cx="11" cy="12" r="11" fill="#eb001b" />
      <circle cx="21" cy="12" r="11" fill="#f79e1b" />
      <path
        d="M16 4 a11 11 0 0 1 0 16 a11 11 0 0 1 0 -16"
        fill="#ff5f00"
      />
    </g>
  </svg>
);
